// Tracciamento eventi/conversioni Google (GA4 + Google Ads).
// Gli ID e le etichette sono letti dinamicamente da /api/config (pannello Admin):
// appena vengono configurati l'ID Ads e le etichette, le conversioni partono
// automaticamente, senza modifiche al codice.
import { getConfig } from "@/lib/api";

let cfgPromise = null;
const loadCfg = () => {
  if (!cfgPromise) cfgPromise = getConfig().catch(() => ({}));
  return cfgPromise;
};

const hasGtag = () => typeof window !== "undefined" && typeof window.gtag === "function";

const fire = (event, params) => {
  if (hasGtag()) {
    window.gtag("event", event, params);
  }
};

// Inizio acquisto: scatta al click su "Paga con PayPal".
export const trackBeginCheckout = async ({ value, currency = "EUR", items = [] } = {}) => {
  const c = await loadCfg();
  // Evento ecommerce GA4 (attivo quando GA4/Ads e' configurato)
  fire("begin_checkout", { currency, value: Number(value) || 0, items });
  // Conversione Google Ads (solo se e' configurata l'etichetta dedicata al checkout)
  const ads = (c.google_ads_id || "").trim();
  const label = (c.google_ads_label_checkout || "").trim();
  if (ads && label) {
    fire("conversion", { send_to: `${ads}/${label}`, value: Number(value) || 0, currency });
  }
};

// Acquisto completato: scatta sulla pagina /success.
export const trackPurchase = async ({ value, transactionId, currency = "EUR", items = [] } = {}) => {
  const c = await loadCfg();
  // Evento ecommerce GA4 (deduplicato lato Google tramite transaction_id)
  fire("purchase", { transaction_id: transactionId, currency, value: Number(value) || 0, items });
  // Conversione Google Ads (etichetta acquisto principale)
  const ads = (c.google_ads_id || "").trim();
  const label = (c.google_ads_label || "").trim();
  if (ads && label) {
    fire("conversion", {
      send_to: `${ads}/${label}`,
      value: Number(value) || 0,
      currency,
      transaction_id: transactionId,
    });
  }
};
